import * as React from 'react'
// import PlayIconImg from '../../../assets/images/header/video-img.svg'
import CollegeHeaderImg from '../../../assets/images/header/header-college-desktop.svg'
import HeaderRewardAnimation from '../../../assets/images/header/animacion-seccion-banner-home.png'
import HeaderRewardAnimationeEc from '../../../assets/images/header/Premio-home.png'
import HeaderRewardAnimationePe from '../../../assets/images/header/GF-PREMIO-PE.png'
import HeaderRewardAnimationePeDesk from '../../../assets/images/header/Premio-home-desktop.png'
import LastStageIcon from '../../../assets/images/header/icon-desktop4.svg'
import { participationSteps, participationStages } from './header-info'
import { Context } from '../../../context/app-context'
import useMediaQuery from '../../../shared/utils/useMediaQuery'
import './header-college.scss'

export const HeaderCollege = () => {
  const { hasParticipation } = React.useContext(Context)
  const redirectionForm = hasParticipation ? '#registrar-claves' : '#registrate'
  const steps = participationSteps(redirectionForm)
  const isMobile = useMediaQuery()

  return (
    <section className="f-header-college" id="participar">
      <div className="f-header-college__left">
        {/* <a href="https://www.youtube.com/watch?v=3hWbIsVhVQ8&t=1s" className="f-header-college__left__play-icon">
          <img src={PlayIconImg} alt="play icon" />
        </a> */}
      </div>

      <div className="f-header-college__center">
        <img
          src={CollegeHeaderImg}
          alt="college challenge"
          className="f-header-college__center__college-img"
        />
        {/* <a
          href="https://www.youtube.com/watch?v=3hWbIsVhVQ8&t=1s"
          className="f-header-college__center__play-icon-mobile"
        >
          <img src={PlayIconImg} alt="play icon" />
        </a> */}

        <h2 className="f-header-college__center__title">¿Cómo participar?</h2>

        <ul className="f-header-college__center__participation" id='steps'>
          {steps.map((step, index) => {
            return (
              <li
                key={index}
                className="f-header-college__center__participation__step"
              >
                <img
                  src={step.icon}
                  alt={'icon' + index}
                  className="f-header-college__center__participation__step__icon"
                />
                <p className="f-header-college__center__participation__step__description">
                  {step.description}
                </p>
              </li>
            )
          })}

        </ul>
      </div>

      <div className="f-header-college__right">
        <img
          src={ process.env.LOCALE === "es-EC" ? HeaderRewardAnimationeEc : process.env.LOCALE === "es-PE" & !isMobile ? HeaderRewardAnimationePeDesk : process.env.LOCALE === "es-PE" ? HeaderRewardAnimationePe : HeaderRewardAnimation }
          alt="phone icon"
          className={"f-header-college__right__cellphone-icon" + process.env.LOCALE === "es-PE" ? "peru" : ""}
        />
        {
          process.env.LOCALE === "es-PE" ?
          <h3 className="f-header-college__right__title">¡Coorre a <p>participar!</p></h3>
          :
          <h3 className="f-header-college__right__title">Serán {participationStages.length} etapas:</h3>
        }
        {
          process.env.LOCALE !== "es-PE" ?
          <ul className="f-header-college__right__stages">
          {participationStages.map(
            ({ title, description, winnersNumber }, index) => {
              return (
                <li
                  className="f-header-college__right__stages__stage"
                  key={index}
                >
                  <p className="f-header-college__right__stages__stage__title">
                    <b>{title}</b> {description}
                  </p>
                  <span className="f-header-college__right__stages__stage__winners">
                    {winnersNumber}
                  </span>
                </li>
              )
            }
          )}
          <p className='f-header-college__right__footer-text' >¡Corre a participar!</p>
        </ul>
        :
        ''
        }

      </div>
    </section>
  )
}
